import React from 'react';
import OrderCard from './orderCard';

export default (props) => <OrderCard {...props} />;
